import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import SectionTitle from '@/components/base/SectionTitle';
import ArticleCard from '@/components/feature/ArticleCard';

export default function LatestSection() {
  const latest = articles.slice(0, 3);
  return (
    <section className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <SectionTitle
        mark="最新"
        title="最新考据内容"
        subtitle="CP线复盘、名场面盘点、师门日常合集持续更新，跟着节奏慢慢嗑。"
      />
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {latest.map((a) => (
          <ArticleCard key={a.id} article={a} />
        ))}
      </div>
      <div className="mt-8 text-center">
        <Link
          to="/daily"
          className="inline-flex items-center gap-2 rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          查看全部内容 <i className="ri-arrow-right-line" />
        </Link>
      </div>
    </section>
  );
}